'use client'

import {
    Flex,
    Container,
    Heading,
    Stack,
    Text,
    Button,
    Icon,
    IconProps,
    Image,
} from '@chakra-ui/react'
import { useState } from 'react';
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Landing from "./landing"

export default function ChooseLanding() {

    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
        if (user) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false)
        }
        setIsLoading(false)
    });
    return (
        isLoading ? (
            <></>
        ) : isLoggedIn ? (
            <Navigate to="/tasks" replace />
        ) : (
            <Landing />
        )
    )
}